import React from 'react';

const FormIcon = ({showNewUI, fillColor = '#2961ff', size = '40'}) =>
  showNewUI ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 16 18"
      fill="none">
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M14.667 5.875V14c0 2.5-1.492 3.333-3.334 3.333H4.667c-1.842 0-3.334-.833-3.334-3.333V5.875c0-2.708 1.492-3.333 3.334-3.333 0 .516.208.983.55 1.325.341.341.808.55 1.325.55h2.916a1.878 1.878 0 0 0 1.875-1.875c1.842 0 3.334.625 3.334 3.333Z"
      />
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M11.333 2.542a1.878 1.878 0 0 1-1.875 1.875H6.542c-.517 0-.984-.209-1.325-.55a1.864 1.864 0 0 1-.55-1.325c0-1.034.841-1.875 1.875-1.875h2.916c.517 0 .984.208 1.325.55.342.341.55.808.55 1.325ZM4.667 9.833H8M4.667 13.167h6.666"
      />
    </svg>
  ) : (
    <svg
      id="Form"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 72 72">
      <circle
        id="Ellipse_702"
        data-name="Ellipse 702"
        cx="36"
        cy="36"
        r="36"
        fill="rgba(41,97,250,0)"
      />
      <path
        id="Path_65849"
        data-name="Path 65849"
        d="M514.7,34.973H492.984a6.725,6.725,0,0,1-6.784-6.664V6.974A6.732,6.732,0,0,1,492.984.31H514.7a6.725,6.725,0,0,1,6.784,6.664V28.309A6.725,6.725,0,0,1,514.7,34.973Zm-21.719-32a4.043,4.043,0,0,0-4.072,4V28.309a4.036,4.036,0,0,0,4.072,4H514.7a4.1,4.1,0,0,0,2.881-1.17,3.957,3.957,0,0,0,1.191-2.83V6.974a4.036,4.036,0,0,0-4.072-4Z"
        transform="translate(-468.145 17.898)"
        fill={fillColor}
      />
      <path
        id="Path_65850"
        data-name="Path 65850"
        d="M496.15,38.963a1.373,1.373,0,0,1,1.373-1.373h7.869a1.373,1.373,0,1,1,0,2.747H497.5A1.373,1.373,0,0,1,496.15,38.963Z"
        transform="translate(-471.264 5.725)"
        fill={fillColor}
      />
      <path
        id="Path_65851"
        data-name="Path 65851"
        d="M496.15,11.793a1.373,1.373,0,0,1,1.373-1.373H516.44a1.373,1.373,0,0,1,0,2.747H497.5A1.373,1.373,0,0,1,496.15,11.793Z"
        transform="translate(-471.264 14.597)"
        fill={fillColor}
      />
      <path
        id="Path_65852"
        data-name="Path 65852"
        d="M496.15,20.845a1.373,1.373,0,0,1,1.373-1.373H516.44a1.373,1.373,0,1,1,0,2.712H497.5A1.373,1.373,0,0,1,496.15,20.845Z"
        transform="translate(-471.264 11.646)"
        fill={fillColor}
      />
      <path
        id="Path_65853"
        data-name="Path 65853"
        d="M496.15,29.905a1.373,1.373,0,0,1,1.373-1.373H516.44a1.373,1.373,0,1,1,0,2.712H497.5A1.373,1.373,0,0,1,496.15,29.905Z"
        transform="translate(-471.264 8.688)"
        fill={fillColor}
      />
    </svg>
  );

export default FormIcon;
